import {
  BluetoothScanObservation,
  DiscoveredDeviceType,
} from 'lib/types/bluetoothPairing'

export const aggregateReadings = (
  byScanner: Map<string, BluetoothScanObservation[]>,
): DiscoveredDeviceType[] => {
  const byName: Map<string, { type: DiscoveredDeviceType; macs: Set<string> }> = new Map()
  byScanner.forEach(observations => {
    observations.forEach(obs => {
      if (!obs.name) return
      const key = obs.name
      const mac = obs.mac.toLowerCase()
      const existing = byName.get(key)
      if (!existing) {
        byName.set(key, {
          type: {
            name: obs.name,
            deviceCount: 1,
            lastSeenAt: obs.seenAt,
          },
          macs: new Set([mac]),
        })
        return
      }
      if (obs.seenAt > existing.type.lastSeenAt) existing.type.lastSeenAt = obs.seenAt
      existing.macs.add(mac)
      existing.type.deviceCount = existing.macs.size
    })
  })
  return Array.from(byName.values())
    .map(v => v.type)
    .sort((a, b) => a.name.localeCompare(b.name))
}
